import { useState, useEffect } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };

const GOWRI = [
  {mani:'06.00-07.30',Sunday:'உத்தி',Monday:'அமிர்',Tuesday:'ரோகம்',Wednesday:'லாபம்',Thursday:'தனம்',Friday:'சுகம்',Saturday:'சோரம்'},
  {mani:'07.30-09.00',Sunday:'அமிர்தம்',Monday:'விஷம்',Tuesday:'லாபம்',Wednesday:'தனம்',Thursday:'சுகம்',Friday:'சோரம்',Saturday:'உத்யோ'},
  {mani:'09.00-10.30',Sunday:'ரோக',Monday:'ரோக',Tuesday:'தனம்',Wednesday:'சுகம்',Thursday:'சோரம்',Friday:'உத்யோ',Saturday:'விஷம்'},
  {mani:'10.30-12.00',Sunday:'லாபம்',Monday:'லாபம்',Tuesday:'சுகம்',Wednesday:'சோரம்',Thursday:'உத்யோ',Friday:'விஷம்',Saturday:'அமிர்தம்'},
  {mani:'12.00-01.30',Sunday:'தனம்',Monday:'தனம்',Tuesday:'சோரம்',Wednesday:'விஷம்',Thursday:'அமிர்தம்',Friday:'அமிர்தம்',Saturday:'ரோகம்'},
  {mani:'13.30-15.00',Sunday:'சுகம்',Monday:'சுகம்',Tuesday:'உத்யோ',Wednesday:'உத்யோ',Thursday:'விஷம்',Friday:'ரோகம்',Saturday:'லாபம்'},
  {mani:'15.00-16.30',Sunday:'சோரம்',Monday:'சோரம்',Tuesday:'விஷம்',Wednesday:'அமிர்தம்',Thursday:'ரோகம்',Friday:'லாபம்',Saturday:'தனம்'},
  {mani:'16.30-18.00',Sunday:'விஷம்',Monday:'உத்யோ',Tuesday:'அமிர்தம்',Wednesday:'ரோகம்',Thursday:'லாபம்',Friday:'தனம்',Saturday:'சுகம்'},
  {mani:'18.00-19.30',Sunday:'தனம்',Monday:'சுகம்',Tuesday:'சோரம்',Wednesday:'உத்யோ',Thursday:'அமிர்தம்',Friday:'ரோகம்',Saturday:'லாபம்'},
  {mani:'19.30-21.00',Sunday:'சுகம்',Monday:'சோரம்',Tuesday:'உத்யோ',Wednesday:'அமிர்தம்',Thursday:'விஷம்',Friday:'லாபம்',Saturday:'தனம்'},
  {mani:'21.00-22.30',Sunday:'சோரம்',Monday:'உத்யோ',Tuesday:'விஷம்',Wednesday:'ரோகம்',Thursday:'ரோகம்',Friday:'தனம்',Saturday:'சுகம்'},
  {mani:'22.30-24.00',Sunday:'விஷம்',Monday:'அமிர்தம்',Tuesday:'அமிர்தம்',Wednesday:'லாபம்',Thursday:'லாபம்',Friday:'சுகம்',Saturday:'சோரம்'},
  {mani:'24.00-25.30',Sunday:'உத்யோ',Monday:'விஷம்',Tuesday:'ரோகம்',Wednesday:'தனம்',Thursday:'தனம்',Friday:'சோரம்',Saturday:'உத்யோ'},
  {mani:'25.30-27.00',Sunday:'அமிர்தம்',Monday:'ரோகம்',Tuesday:'லாபம்',Wednesday:'சுகம்',Thursday:'சுகம்',Friday:'உத்யோ',Saturday:'விஷம்'},
  {mani:'27.00-28.30',Sunday:'ரோகம்',Monday:'லாபம்',Tuesday:'தனம்',Wednesday:'சோரம்',Thursday:'சோரம்',Friday:'விஷம்',Saturday:'அமிர்தம்'},
  {mani:'28.30-06.00',Sunday:'லாபம்',Monday:'தனம்',Tuesday:'சுகம்',Wednesday:'விஷம்',Thursday:'உத்யோ',Friday:'அமிர்தம்',Saturday:'சோரம்'},
];
const DAYS_EN = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const DAYS_TA = ['ஞாயிறு','திங்கள்','செவ்வாய்','புதன்','வியாழன்','வெள்ளி','சனி'];

const gowriColor = (v) => {
  if (!v) return '#333';
  if (v.includes('அமிர்')) return '#1b5e20';
  if (v.includes('சுகம்')) return '#2e7d32';
  if (v.includes('லாபம்')||v.includes('தனம்')) return '#1565c0';
  if (v.includes('உத்யோ')||v.includes('உத்தி')) return '#6a1b9a';
  if (v.includes('விஷம்')||v.includes('ரோக')||v.includes('சோரம்')) return '#c62828';
  return '#333';
};

const GowriPanchangamPage = () => {
  const [tab, setTab] = useState('gowri');
  const [pakshi, setPakshi] = useState([]);
  const [pakshi2, setPakshi2] = useState([]);
  const [vetri, setVetri] = useState([]);
  const [starNo, setStarNo] = useState(1);
  const today = new Date().getDay();

  useEffect(() => {
    axios.get('/data/pakshi.json').then(r => setPakshi(r.data)).catch(()=>{});
    axios.get('/data/pakshi2.json').then(r => setPakshi2(r.data)).catch(()=>{});
  }, []);

  useEffect(() => {
    axios.get('/data/vetri.json').then(r => {
      const f = r.data.filter(x => x.id === Math.floor(starNo));
      setVetri(f);
    }).catch(()=>{});
  }, [starNo]);

  const STARS_TA = ['அஸ்வினி','பரணி','கிருத்திகை','ரோகிணி','மிருகசீரிஷம்','திருவாதிரை','புனர்பூசம்','பூசம்','ஆயில்யம்','மகம்','பூரம்','உத்திரம்','அஸ்தம்','சித்திரை','சுவாதி','விசாகம்','அனுஷம்','கேட்டை','மூலம்','பூராடம்','உத்திராடம்','திருவோணம்','அவிட்டம்','சதயம்','பூரட்டாதி','உத்திரட்டாதி','ரேவதி'];

  const grouped = (data, bird) => data.filter(x => x.Pakshi === bird);

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>🕊️ கௌரி பஞ்சாங்கம்</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Gowri Panchangam • Pakshi Saastram • Vetri Chakram</div>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',gap:'2px',marginBottom:'10px'}}>
        {[['gowri','கௌரி'],['pakshi','பக்ஷி'],['vetri','வெற்றி']].map(([id,label])=>(
          <button key={id} onClick={()=>setTab(id)} style={{flex:1,border:'none',padding:'8px',borderRadius:'8px 8px 0 0',
            fontWeight:700,fontSize:'0.8rem',cursor:'pointer',background:tab===id?T.greenDk:'#fff',color:tab===id?'#fff':T.greenDk}}>{label}</button>
        ))}
      </div>

      {/* Gowri Table */}
      {tab==='gowri' && (
        <div style={{overflowX:'auto'}}>
          <div style={{fontWeight:700,fontSize:'0.8rem',color:T.greenDk,textAlign:'center',marginBottom:'6px'}}>
            இன்று: {DAYS_TA[today]} — நல்ல நேரம் பச்சை நிறத்தில்
          </div>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.6rem'}}>
            <thead>
              <tr style={{background:T.greenDk,color:'#fff'}}>
                <th style={{padding:'5px 3px',border:'1px solid #ccc'}}>மணி</th>
                {DAYS_TA.map((d,i)=><th key={i} style={{padding:'5px 3px',border:'1px solid #ccc',background:i===today?'#ff9800':T.greenDk}}>{d}</th>)}
              </tr>
            </thead>
            <tbody>
              {GOWRI.map((row,ri)=>(
                <tr key={ri} style={{background:ri<8?'#fff':'#f5f0ff'}}>
                  <td style={{padding:'4px 3px',border:'1px solid #eee',fontWeight:700,fontSize:'0.55rem',whiteSpace:'nowrap'}}>{row.mani}</td>
                  {DAYS_EN.map((d,di)=>(
                    <td key={di} style={{padding:'4px 2px',border:'1px solid #eee',textAlign:'center',fontWeight:600,
                      color:gowriColor(row[d]),background:di===today?'#fff8e1':'transparent',fontSize:'0.55rem'}}>{row[d]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{fontSize:'0.6rem',padding:'6px',color:T.maroon,background:'#fff3e0',borderRadius:'6px',marginTop:'6px'}}>
            🟢 அமிர்தம்/சுகம்/லாபம்/தனம் = நல்ல நேரம் | 🔴 விஷம்/ரோகம்/சோரம் = தவிர்க்கவும்
          </div>
        </div>
      )}

      {/* Pakshi Tab */}
      {tab==='pakshi' && (
        <div>
          <div style={{fontWeight:700,fontSize:'0.85rem',color:T.greenDk,textAlign:'center',marginBottom:'8px'}}>பஞ்ச பக்ஷி சாஸ்திரம்</div>
          <div style={{textAlign:'center',fontSize:'0.7rem',marginBottom:'10px'}}>
            <span style={{color:'#1b5e20',fontWeight:'bold'}}>வளர்பிறை (Waxing Moon)</span> மற்றும் <span style={{color:'#6d1b1b',fontWeight:'bold'}}>தேய்பிறை (Waning Moon)</span>
          </div>
          {['வல்லூறு','ஆந்தை','காகம்','கோழி','மயில்'].map(bird => {
            const d1 = grouped(pakshi, bird);
            const d2 = grouped(pakshi2, bird);
            if (!d1.length && !d2.length) return null;
            return (
              <div key={bird} style={{background:T.cream,borderRadius:'8px',padding:'8px',marginBottom:'15px',border:'1px solid '+T.border}}>
                <div style={{fontWeight:800,fontSize:'1rem',color:T.maroon,marginBottom:'8px',textAlign:'center'}}>🐦 {bird}</div>
                
                {/* Valarpirai */}
                {d1.length > 0 && (
                  <div style={{marginBottom:'10px', overflowX:'auto'}}>
                    <div style={{fontWeight:700,fontSize:'0.75rem',color:'#1b5e20',marginBottom:'4px'}}>வளர்பிறை:</div>
                    <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.55rem',textAlign:'center'}}>
                      <thead>
                        <tr style={{background:T.greenDk,color:'#fff'}}>
                          <th style={{padding:'4px',border:'1px solid #ccc',minWidth:'50px'}}>Day</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>06:00<br/>08:24</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>08:24<br/>10:48</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>10:48<br/>13:12</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>13:12<br/>15:36</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>15:36<br/>18:00</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>18:00<br/>20:24</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>20:24<br/>22:48</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>22:48<br/>01:12</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>01:12<br/>03:36</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>03:36<br/>06:00</th>
                        </tr>
                      </thead>
                      <tbody>
                        {d1.slice(0,7).map((r,i)=>(
                          <tr key={i} style={{background:i%2?'#f5f5f5':'#fff'}}>
                            <td style={{padding:'4px',border:'1px solid #eee',fontWeight:'bold'}}>{r.Day}</td>
                            {[1,2,3,4,5,6,7,8,9,10].map(j => (
                              <td key={j} style={{padding:'4px',border:'1px solid #eee'}}>{r[`jamam${j}`]}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Theipirai */}
                {d2.length > 0 && (
                  <div style={{overflowX:'auto'}}>
                    <div style={{fontWeight:700,fontSize:'0.75rem',color:'#6d1b1b',marginBottom:'4px'}}>தேய்பிறை:</div>
                    <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.55rem',textAlign:'center'}}>
                      <thead>
                        <tr style={{background:'#6d1b1b',color:'#fff'}}>
                          <th style={{padding:'4px',border:'1px solid #ccc',minWidth:'50px'}}>Day</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>06:00<br/>08:24</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>08:24<br/>10:48</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>10:48<br/>13:12</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>13:12<br/>15:36</th>
                          <th style={{padding:'4px',border:'1px solid #ccc'}}>15:36<br/>18:00</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>18:00<br/>20:24</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>20:24<br/>22:48</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>22:48<br/>01:12</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>01:12<br/>03:36</th>
                          <th style={{padding:'4px',border:'1px solid #ccc',background:'#333'}}>03:36<br/>06:00</th>
                        </tr>
                      </thead>
                      <tbody>
                        {d2.slice(0,7).map((r,i)=>(
                          <tr key={i} style={{background:i%2?'#f5f5f5':'#fff'}}>
                            <td style={{padding:'4px',border:'1px solid #eee',fontWeight:'bold'}}>{r.Day}</td>
                            {[1,2,3,4,5,6,7,8,9,10].map(j => (
                              <td key={j} style={{padding:'4px',border:'1px solid #eee'}}>{r[`jamam${j}`]}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Vetri Chakram */}
      {tab==='vetri' && (
        <div>
          <div style={{fontWeight:700,fontSize:'0.85rem',color:T.greenDk,textAlign:'center',marginBottom:'8px'}}>வெற்றி சக்கரம் — நக்ஷத்ரம் தேர்வு</div>
          <select value={starNo} onChange={e=>setStarNo(parseInt(e.target.value))}
            style={{width:'100%',padding:'8px',borderRadius:'8px',border:'2px solid '+T.greenDk,fontSize:'0.85rem',fontWeight:700,marginBottom:'10px'}}>
            {STARS_TA.map((s,i)=><option key={i} value={i+1}>{i+1}. {s}</option>)}
          </select>
          {vetri.length > 0 && (
            <div style={{overflowX:'auto'}}>
              <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.65rem'}}>
                <thead><tr style={{background:T.greenDk,color:'#fff'}}>
                  {Object.keys(vetri[0]).filter(k=>k!=='id').map(k=><th key={k} style={{padding:'4px',border:'1px solid #ccc'}}>{k}</th>)}
                </tr></thead>
                <tbody>
                  {vetri.map((r,i)=>(
                    <tr key={i} style={{background:i%2?'#f5f5f5':'#fff'}}>
                      {Object.entries(r).filter(([k])=>k!=='id').map(([k,v],j)=>(
                        <td key={j} style={{padding:'4px',border:'1px solid #eee',fontWeight:j===0?700:400}}>{String(v)}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default GowriPanchangamPage;